import api from 'data/api';

export const loadOwners = api('GET /api/mobile/lookups/owners');
